import { createContext } from "react";
import { EffectiveEntitlementResponse, FamilySummary, Package } from "../helper/interface";

export interface PackageContextType {
  packages: Package[];
  families: FamilySummary[];
  personalPackage: Package | null;
  familyPackage: Package | null;
  effectivePackage: Package | null;
  currentPackage: Package | null;
  activeFamilyId: string | null;
  activeFamilyName: string | null;
  familySubscriptionStatus?: string | null;
  isFamilyContext: boolean;
  usedLegacyFallback: boolean;
  familyId?: string | null;
  familySubscriptionId?: string | null;
  loading: boolean;
  familyLoading: boolean;
  refreshPackage: () => Promise<void>;
  refreshFamilies: () => Promise<void>;
  setActiveFamilyId: (familyId: string | null) => void;
  lastEntitlement?: EffectiveEntitlementResponse | null;
}

export const PackageContext = createContext<PackageContextType | undefined>(
  undefined
);
